/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./number-input.vue?vue&type=template&id=38c976b6&"
import script from "./number-input.vue?vue&type=script&lang=ts&"
export * from "./number-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports